import Vue from 'vue'

const state = {
  getText:'',
  setText:'',
  title:''
}
const actions = {
  updateGetText({commit}, getText){
    commit("UPDATE_GET_TEXT", getText);
  },
  updateSetText({commit}, setText){
    commit("UPDATE_SET_TEXT", setText);
  },
  updateTitle({commit}, title){
    commit("UPDATE_TITLE", title);
  }
}

const mutations = {
  ["UPDATE_GET_TEXT"](state, getText) {
    Vue.set(state, 'getText', getText);
  },
  ["UPDATE_SET_TEXT"](state,setText) {
    Vue.set(state, 'setText', setText);
  },
  ["UPDATE_TITLE"](state,title) {
    Vue.set(state, 'title', title);
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/editor.js